<template>
    <div
        :class="`formulate-input-element formulate-input-element--${context.class}`"
        :data-type="context.type"
    >
        <div class="d-flex flex-row align-items-center">
            <input
                class="flex-grow"
                type="text"
                v-model="context.model"
                v-bind="context.attributes"
                autocomplete="no"
            />
            <div class="formulate-input-addon color-picker-container position-relative ml-1">
                <verte
                    v-model="currentColor"
                    :picker="shape"
                    :model="mode"
                    :menuPosition="position"
                    :draggable="false"
                    :enableAlpha="false"
                    :showHistory="null"
                    @input="doPickColor"
                >
                    <svg version="1.1" viewBox="0 0 35 35" xmlns="http://www.w3.org/2000/svg" v-bind:style="isWhite ? {border: '1px solid #CCC'} : {}">
                        <rect x="4.7684e-8" y="4.7684e-8" width="35" height="35" fill-rule="evenodd"/>
                    </svg>
                </verte>
            </div>
        </div>
    </div>
</template>

<script>
import { debounce } from 'lodash';
import Verte from 'verte'; // https://baianat.github.io/verte/
import 'verte/dist/verte.css';

import { validHexCode } from '@/helper/regex';

export default {
    components: {
        Verte,
    },
    props: {
        context: {
            type: Object,
            required: true
        },
        mode: {
            type: String,
            default: 'hex',
        },
        shape: {
            type: String,
            default: 'square',
        },
        position: {
            type: String,
            default: 'left',
        },
    },
    data() {
        return {
            currentColor: null,
        }
    },
    mounted() {
        this.currentColor = this.context.model;
    },
    computed: {
        isWhite() {
            return this.currentColor === '#FFF' || this.currentColor === '#FFFFFF' ||
                this.currentColor === '#fff' || this.currentColor === '#ffffff';
        },
    },
    watch: {
        'context.model': {
            immediate: true,
            handler: debounce(function(newValue, oldValue) {
                if (newValue) {
                    const test = validHexCode.test(newValue);
                    if (test) {
                        this.currentColor = newValue;
                    }
                }
            }, 1000)
        },
    },
    methods: {
        doPickColor(color) {
            if (color !== this.context.model) {
                this.context.model = color;
            }
        },
    },
};
</script>

<style scoped>
>>>.verte__guide {
    width: 35px;
    height: 35px;
}

>>>.verte__menu-origin--left {
    left: -200px;
    top: 35px;
}
</style>

